import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import { sessionSelector } from "@/store/sessionReducer";
import { addBreadcrumbItem, removeBreadcrumbItem } from "@/store/sessionReducer";

import { useAppDispatch, useAppSelector } from ".";

export default function useI18nBreadcrumb<T>(
  identifier: string,
  fun: I18nBreadcrumbCallbackType<T>,
  resource?: BreadcrumbResourceType<T>,
  namespaces: string[] = ["translation"],
) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(namespaces);
  const { currentProject, currentCustomer, currentUser } = useAppSelector(sessionSelector);
  let dep;

  if (resource && "id" in (resource as any)) {
    dep = (resource as any).id;
  } else if (resource && typeof (resource as any).toString) {
    dep = (resource as any).toString();
  } else {
    dep = resource;
  }

  useEffect(
    () => {
      const item = fun(t, { currentCustomer, currentProject, currentUser } as SessionInterface, resource);
      dispatch(addBreadcrumbItem(item));

      return () => {
        dispatch(removeBreadcrumbItem(identifier));
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fun, identifier, currentCustomer.id, currentProject.id, currentUser.id, dep],
  );
}
